import { FILE } from '../constants';
import { FileAttributes, FileElement } from '../types';

/** Create a wrex file element object. */
export const createFile = (attributes: FileAttributes): FileElement => {
    return { ...attributes, type: FILE, children: [{ text: '' }] };
};
